import styled from 'styled-components'

import {tokens} from '@pleo-io/telescope'

import {breakpoints} from '@product-web/styles/theme'

export const Wrapper = styled.section`
    display: grid;
    grid-template-areas: 'content illustration';
    grid-template-columns: 55% 1fr;
    grid-template-rows: auto;
    align-content: stretch;
    min-height: 100%;
    height: 100vh;
    width: 100vw;

    @media (max-width: ${breakpoints.tabletUp}) {
        grid-template-areas:
            'content'
            'illustration';
        grid-template-columns: 1fr;
        grid-template-rows: 100vh 0;
        align-content: stretch;
        overflow: hidden;
    }
`

export const Content = styled.div`
    display: grid;
    grid-template-areas:
        'logo'
        'form'
        'bottomNav';
    grid-template-columns: 1fr;
    grid-template-rows: 125px 1fr 60px;
    align-content: stretch;
    overflow: hidden;
`

export const Logo = styled.div`
    grid-area: logo;
    margin-left: ${tokens.spacing48};
    margin-top: ${tokens.spacing48};
`

export const Form = styled.div`
    grid-area: form;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    section {
        width: 100%;
        max-width: 400px;
    }

    @media (max-width: ${breakpoints.smallTabletUp}) {
        padding: 0 10%; /* stylelint-disable-line */
    }
`

export const BottomNav = styled.div`
    color: ${tokens.shade600};
    font-size: 14px;
    padding-left: ${tokens.spacing60};
    grid-area: bottomNav;
`

export const PinIllustration = styled.div`
    height: 150px;
    display: flex;
    justify-content: center;

    img {
        height: 150px;
        width: auto;
    }
`

export const TimerFragmentWrapper = styled.span`
    display: inline-flex;
    width: 41px;
`
